import React from 'react';
import Google from "../../Assets/Images/google.png";
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';
import useFirebase from '../../Hooks/useFirebase';


const SignIn = () => {
    const { signInGoogle } = useFirebase();


    const signIn = () => {
        signInGoogle();
    };

    return (
        <div  style={{ backgroundImage: `url("https://img.freepik.com/premium-photo/set-chinese-dishes-table-space-text_92134-3366.jpg")`}} className='py-20 bg-cover bg-no-repeat w-full mx-auto px-7'>
            <div className="flex bg-cover bg-no-repeat flex-col md:flex-row gap-3 justify-center items-center w-full mx-auto">
                <div className="w-full mx-auto flex justify-center ">
                    <div className="mockup-phone">
                        <div className="camera"></div>
                        <div className="display">
                            <div className="artboard artboard-demo p-5 phone-1 w-full flex justify-center">
                                <img src={Google} alt="" className="w-[50%] md:w-[30%] object-cover p-5" />
                                <h1 className="text-3xl md:text-5xl font-bold fw-bold capitalize" style={{ fontFamily: "Rajdhani" }}>Sign In</h1>
                                <p className="app__Signin-text text-md">SignIn With Google Using Firebase.</p>
                                <div onClick={signIn} className="flex rounded-full hover:shadow-lg px-5 cursor-pointer w-full bg-[#c4c4c4e7] justify-evenly items-center gap-3">
                                    <img src={Google} alt="" className="w-16 object-cover px-3 py-1" />
                                    <h3 className="font-bold font-serif text-md md:text-md">Signin With Google</h3>
                                </div>
                                <div className="app__footer-links_icons pt-10 flex mx-auto w-full justify-center">
                                    <FiFacebook />
                                    <FiTwitter />
                                    <FiInstagram />
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SignIn;